import React from 'react';
import HubScreen from './HubScreen';
import LocationEditor from './LocationEditor';
import VerifyQueue from './VerifyQueue';
import LocationProfile from './LocationProfile';
import PlaceSuggestions from './PlaceSuggestions';

const TABS = [
  { id: 'locationeditor', label: 'Location Editor', Component: LocationEditor },
  { id: 'verifyqueue', label: 'Verify Queue', Component: VerifyQueue },
  { id: 'placesuggestions', label: 'Suggestions', Component: PlaceSuggestions },
  { id: 'locationprofile', label: 'Location Search', Component: LocationProfile },
];

export default function LocationsHub(props) {
  return <HubScreen tabs={TABS} hubId="locations" passProps={props} />;
}
